import { ChangeDetectionStrategy, Component, output } from "@angular/core";
import { ButtonComponent } from "../../inputs/button/button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-error-page",
  templateUrl: "./error-page.component.html",
  imports: [ButtonComponent, TranslateModule],
})
export class ErrorPageComponent {
  readonly tryAgain$ = output<void>();

  constructor() {}

  tryAgain(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.tryAgain$.emit();
  }
}
